import { useEffect, useState } from 'react';

import { isFirstLoad, allmenu, isSingin } from '../redux/slices/initLoad/types';
import { store } from '../redux/store';
import request from '../helpers/requests';
import { saveData, saveImage, getImage } from '../helpers/indexedDbHelper';

export const useInit = () => {
  const [progress, setProgress] = useState(0); // progress in %
  const downloadImage = async (url, id, changeimage) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      await saveImage(id, { blob, changeimage });
    } catch (error) {
      console.error(`Error al descargar la imagen ${id}:`, error);
    }
  };

  const getInitData = async () => {
    const hash = '7122121124d0ponchesuizo390b0a72ac210dad121';

    const { data } = await request.get(`/all/menu/web/${hash}`);
    console.log('guardando menu');
    await saveData('menu', data);
    console.log('menu guardado');

    const validImages = async (id) => {
      console.log('validando imagen');
      const data = await getImage(id);
      console.log('imagen validada');
      return data;
    };

    // Crear una lista de promesas para todas las imágenes
    const downloadPromises = [];
     
    const downloadCatPromises = [];
    let imagesMap = new Map();

    data.data.forEach((item) => {
      const images = [
        ...item.menus.map((menu) => ({
          url: menu.image,
          changeimage: menu.changeimage,
          id: `menu-image-${menu.id}`,
        })),
        ...item.menus.map((menu) => ({
          url: menu.imagehorizontal,
          changeimage: menu.changeimagehorizontal,
          id: `menu-image-h-${menu.id}`,
        })),
        ...item.menus.map((menu) => ({
          url: menu.image1,
          changeimage: menu.changeimage1,
          id: `menu-image-one-${menu.id}`,
        })),
        ...item.menus.map((menu) => ({
          url: menu.image2,
          changeimage: menu.changeimage2,
          id: `menu-image-two-${menu.id}`,
        })),
      ];

      images.forEach((img) => {
        if (img.url) {
          imagesMap.set(img.id, img);
        }
      });
    });


        data.data.forEach((item) => {
      const url = item.icon;
      const id = `menu-cat-${item.id}`;
      if (url) {
          const fullUrl = `https://admin.boostmymenu.com/images/categories/icons/${url}`;
          downloadCatPromises.push(
            (async () => {
              const validImage = await validImages(id);
             
                if (!validImage || !validImage.data) {
                  console.log('Downloading image cat', fullUrl, id);
                  await downloadImage(fullUrl, id, "changeimage");
                }
            })()
          );
        }
        });
    

    let allImages = Array.from(imagesMap.values());
    const totalImages = allImages.length;
    let completed = 0;

    const processBatch = async (batch) => {
      const concurrencyLimit = 100;
      for (let i = 0; i < batch.length; i += concurrencyLimit) {
        const subBatch = batch.slice(i, i + concurrencyLimit);
        await Promise.all(
          subBatch.map(async ({ url, id, changeimage }) => {
            const fullUrl = `https://admin.boostmymenu.com/images/menus/${url}`;
            const validImage = await validImages(id);

            if (
              !validImage ||
              !validImage.data ||
              validImage.data.changeimage != changeimage
            ) {
              console.log('Downloading image', fullUrl, id);
              await downloadImage(fullUrl, id, changeimage);
            }
            completed++;
            setTimeout(() => {
              setProgress(Math.round((completed / totalImages) * 100));
            }, [500]);
          }),
        );
      }
    };

    console.log('Esperar a que todas las imágenes se descarguen');
    // Esperar a que todas las imágenes se descarguen
    const chunkSize = 100;
    for (let i = 0; i < allImages.length; i += chunkSize) {
      const batch = allImages.slice(i, i + chunkSize);
      console.log('terminando imágenes se descarguen');
      await processBatch(batch);
    }

    // Actualizar el estado de Redux
    console.log('terminar proceso');
    store.dispatch(isSingin(true));
    store.dispatch(isFirstLoad(false));
  };

  useEffect(() => {
    const isGoodConnection = () => {
      const connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
      if (connection) {
        const slowConnections = ['slow-2g', '2g'];
        if (
          slowConnections.includes(connection.effectiveType) ||
          connection.saveData
        ) {
          return false;
        }
      }
      return true;
    };

    const hasInternetAccess = async () => {
      try {
        const response = await fetch('https://admin.boostmymenu.com/api/health', {
          method: 'GET',
          cache: 'no-store',
        });

        return response.ok;
      } catch (error) {
        return false;
      }
    };

    const checkAndStart = async () => {
      const online = navigator.onLine;
      const goodConnection = isGoodConnection();
      const hasInternet = await hasInternetAccess();

      if (online && goodConnection && hasInternet) {
        console.log('Conexión ok, comenzando init...');
        getInitData();
      } else {
        console.log('Sin conexión real o conexión muy lenta. Esperando...');
        store.dispatch(isSingin(true));
        store.dispatch(isFirstLoad(false));
      }
    };

    setTimeout(() => {
     // store.dispatch(isSingin(true));
       // store.dispatch(isFirstLoad(false));
      checkAndStart();
    }, 3000);
  }, []);

  return { progress };
};

// NEED TO HANDLE MULTIPLE TIME API CALLING getInitData, bcz in index file we are calling
// useInit hook for get progress data so bcz of that api is called 4 times,but we need to manage it for maximum 2 time
// we can pass one flag from index and in this hook add condition that if we find flag then fon't call api otherwise call api
